import { useScroll, useTransform } from "framer-motion"

export default function useParallax(ref) {
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] })
  const y = useTransform(scrollYProgress, [0, 1], ["10%", "-10%"])
  return y
}
